import { ObjectValuesType } from '../helpers/utilities';

export const EditMode = {
  NEW: 'NEW',
  EDIT: 'EDIT',
  CLONE: 'CLONE',
} as const;

export type EditMode = ObjectValuesType<typeof EditMode>;
